export const fileNameFormatter = (name) => {
    name = name.split('-')
    name = name[name.length - 1]
    return name
}
